/**
 * v1 proxy: detected-finding count → 1–4 complexity level.
 *
 * This is a cherry-pick-resistance measure for the worklist — raw counts invite
 * cherry-picking easy (low-count) cases. The mapping is deliberately coarse so
 * the exact count is not legible to the reader.
 *
 * Keep `findingCount` as the single swappable input. When a richer complexity
 * signal (e.g. finding severity, anatomic spread, model confidence spread)
 * replaces this, only this function changes.
 */
export function complexityLevel(findingCount: number): 1 | 2 | 3 | 4 {
  if (findingCount <= 2) return 1;
  if (findingCount <= 5) return 2;
  if (findingCount <= 9) return 3;
  return 4;
}
